import moment from 'moment';
export default {
	getSearchMonths_({ searchParams: { strDt, endDt } }) {
		return [moment(strDt).format('YYYY-MM-DD'), moment(endDt).format('YYYY-MM-DD')];
	},
	//유형(조회조건) selectBox
	getPartClCdList_({ partClCdList }) {
		const list = [];
		partClCdList.length && partClCdList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
		return list;
	}
};
